import React, { Fragment } from "react";
// import { Link } from "react-router-dom";
import BusinessLink from './BusinessLink'
import ThirdPartyLink from './ThirdPartyLink'
import PopUpLink from './PopUpLink'
import navigationmenu from "../../data/navigation.json";
import HeaderComponent from "../../helper/Navigationhelper";
import Location from './Location'
import Contact from './Contact'

class Mobilemenu extends HeaderComponent {
  // eslint-disable-next-line
  constructor(props) {
    super(props);
  }
  render() {

    // const logoUrl = this?.props?.logo
    // const business_name = this?.props?.businessName
    const location_list = this?.props?.locationList
    const custom_page = this?.props?.customPage
    const new_custom_page = this?.props?.newCustomPage
    const isCateringMenu = this?.props?.isCateringMenu
    const isSpecialMenu = this?.props?.isSpecialMenu
    const isShowExtraPage = this?.props?.isShowExtraPage
    const new_custom_page_2 = this?.props?.newCustomPage2
    const new_custom_page_3 = this?.props?.newCustomPage3
    const socialMedia = this?.props?.socialMedia
    const storeAddress = this?.props?.storeAddress
    const bannerInfo = this?.props?.bannerInfo
    const actionButtonText = `${bannerInfo?.call_to_action_button_text || 'Order Online'}`
    const websiteBackgroundColor = this?.props?.websiteBackgroundColor
    const websiteTextColor = this?.props?.websiteTextColor
    const jobsPageShow = this?.props?.jobsPageShow
    const contactSection = this?.props?.contactSection
    const businessId = this?.props?.businessId
    const showGalleryPage = this?.props?.showGalleryPage
    const faqsPageShow = this?.props?.faqsPageShow
    let showPopUp = false
    if (location_list?.length > 1) {
      showPopUp = true
    }

    function string_to_slug(str) {
      str = str.replace(/^\s+|\s+$/g, ''); // trim
      str = str.toLowerCase();

      // remove accents, swap ñ for n, etc
      var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
      var to = "aaaaeeeeiiiioooouuuunc------";
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
      }

      str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

      return str;
    }

    return (
      <Fragment>
        <div className="aside-scroll">
          <ul>
            {navigationmenu.length > 0
              ? navigationmenu.map((item, i) => (
                <li
                  key={i}
                  className={`menu-item ${item.id === 2 && location_list.length > 1 ? "menu-item-has-children" : ""
                    } `}
                  onClick={this.triggerChild}
                >
                  {item.id === 2 && location_list.length > 1 ? (
                    <BusinessLink onClick={(e) => e.preventDefault()} to="/">
                      {" "}
                      {item.linkText}{" "}
                    </BusinessLink>
                  ) : null}
                  {
                    (item.id === 2 && location_list.length <= 1) ||
                      (item.id === 3 && isCateringMenu > 0) ||
                      (item.id === 4 && isSpecialMenu > 0) ||
                      (item.id !== 2 && item.id !== 3 && item.id !== 4 & item.id !== 6) ||
                      (item.id === 6 && showGalleryPage) ?
                      (
                        <BusinessLink to={item.link}> {item.linkText} </BusinessLink>
                      ) : null
                  }
                  {item.id === 2 && location_list.length > 1 ? (
                    <ul className="submenu" role="menu">
                      {location_list.map((sub_item, i) => (
                        <li
                          key={i}
                          className="menu-item"
                        >
                          <BusinessLink to={`/menu/${sub_item.business?.slug}`}>
                            {" "}
                            {`${sub_item.business?.location_name ? sub_item.business.location_name : sub_item.business?.location?.address?.city} Menu`}{" "}
                          </BusinessLink>
                        </li>
                      ))}
                    </ul>
                  ) : null}
                </li>
              ))
              : null}
            {custom_page?.show_custom_page && custom_page?.name && custom_page?.display_type === 'Tab' && (custom_page?.file_url || custom_page?.url_link)
              ? (
                <li
                  key={`custom-1`}
                  className={`menu-item`}
                  onClick={this.triggerChild}
                >
                  <ThirdPartyLink to={custom_page?.file_url || custom_page?.url_link}> {custom_page.name} </ThirdPartyLink>
                </li>
              )
              : null}
            {custom_page?.show_custom_page && custom_page?.name && custom_page?.display_type === 'Popup' && (custom_page?.file_url || custom_page?.url_link)
              ? (
                <li
                  key={`custom-1`}
                  className={`menu-item`}
                  onClick={this.triggerChild}
                >
                  <PopUpLink to={custom_page?.file_url || custom_page?.url_link} page_format={custom_page?.page_format} file_type={custom_page?.file_type}> {custom_page.name} </PopUpLink>
                </li>
              )
              : null}
            {new_custom_page?.show_custom_page && new_custom_page?.name
              ? (
                <li
                  key={`custom-2`}
                  className={`menu-item`}
                  onClick={this.triggerChild}
                >
                  <BusinessLink to={`/page/${string_to_slug(new_custom_page.name)}`}> {new_custom_page.name} </BusinessLink>
                </li>
              )
              : null}
            {new_custom_page_2?.show_custom_page && new_custom_page_2?.name
              ? (
                <li
                  key={`custom-3`}
                  className={`menu-item`}
                  onClick={this.triggerChild}
                >
                  <BusinessLink to={`/page/${string_to_slug(new_custom_page_2.name)}`}> {new_custom_page_2.name} </BusinessLink>
                </li>
              )
              : null}
            {new_custom_page_3?.show_custom_page && new_custom_page_3?.name
              ? (
                <li
                  key={`custom-4`}
                  className={`menu-item`}
                  onClick={this.triggerChild}
                >
                  <BusinessLink to={`/page/${string_to_slug(new_custom_page_3.name)}`}> {new_custom_page_3.name} </BusinessLink>
                </li>
              )
              : null}
            {isShowExtraPage ? (
              <li
                key={`extra`}
                className={`menu-item`}
                onClick={this.triggerChild}
              >
                <BusinessLink to={`/newpage`}> New Page </BusinessLink>
              </li>
            )
              : null}
            {faqsPageShow &&
              <li
                key={`jobs`}
                className={`menu-item`}
                onClick={this.triggerChild}
              >
                {" "}
                <BusinessLink to="/faqs">FAQs</BusinessLink>{" "}
              </li>
            }
            {jobsPageShow &&
              <li
                key={`jobs`}
                className={`menu-item`}
                onClick={this.triggerChild}
              >
                {" "}
                <BusinessLink to="/jobs">Jobs</BusinessLink>{" "}
              </li>
            }
            {contactSection?.contact_form &&
              <li
                key={`contact`}
                className={`menu-item`}
                onClick={this.triggerChild}
              >
                <Contact
                  actionButtonText={actionButtonText}
                  businessCode={businessId}
                  websiteBackgroundColor={websiteBackgroundColor}
                  websiteTextColor={websiteTextColor}
                  hideClassName
                />
              </li>
            }
            {actionButtonText && bannerInfo?.call_to_action_url && showPopUp === false ? (
              <li
                key={`order-page`}
                className={`menu-item `}
              >
                <a href={bannerInfo?.call_to_action_url} style={{ color: websiteTextColor }} rel="noreferrer" target="_blank">{actionButtonText}</a>
              </li>
            )
              : null}
            {actionButtonText && showPopUp === true ? (
              <li
                key={`order-page`}
                className={`menu-item `}
              >
                <Location
                  actionButtonText={actionButtonText}
                  locationInfo={location_list}
                  websiteBackgroundColor={websiteBackgroundColor}
                  websiteTextColor={websiteTextColor}
                  hideClassName
                />
              </li>
            )
              : null}
          </ul>
        </div>
        <div className="footer-widget social-media-border">
          <ul className="social-media">
            <li>
              {" "}
              <a
                href={socialMedia?.facebook || 'https://facebook.com'}
                hidden={!socialMedia?.facebook}
                title="Facebook"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                <i className="fab fa-facebook-f" />{" "}
              </a>{" "}
            </li>
            <li>
              {" "}
              <a
                href={socialMedia?.instagram || 'https://www.instagram.com'}
                hidden={!socialMedia?.instagram}
                title="Instagram"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                <i className="fab fa-instagram" />{" "}
              </a>{" "}
            </li>
            <li>
              {" "}
              <a
                href={socialMedia?.twitter || 'https://www.twitter.com'}
                hidden={!socialMedia?.twitter}
                title="Twitter"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                <i className="fab fa-twitter" />{" "}
              </a>{" "}
            </li>
            <li>
              {" "}
              <a
                href={socialMedia?.yelp || 'https://www.yelp.com'}
                hidden={!socialMedia?.yelp}
                title="Yelp"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                <i className="fab fa-yelp" />{" "}
              </a>{" "}
            </li>
            <li>
              {" "}
              <a
                href={socialMedia?.linkedin}
                hidden={!socialMedia?.linkedin}
                title="LinkedIn"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                <i className="fab fa-linkedin"></i>{" "}
              </a>{" "}
            </li>
            <li>
              {" "}
              <a
                href={socialMedia?.tiktok}
                hidden={!socialMedia?.tiktok}
                title="TikTok"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                <i className="fab fa-tiktok" />{" "}
              </a>{" "}
            </li>
          </ul>
        </div>
        <div className="social-location">
          <a href={`http://www.google.com/maps/search/${storeAddress}`} target="_blank" rel="noreferrer">
            <span>{storeAddress}</span>
          </a>
        </div>
        <div className="slide-menu-footer-text">
          Powered by <a href="https://www.plento.io" rel="noreferrer" target="_blank">Plento</a>
        </div>
      </Fragment>
    );
  }
}

export default Mobilemenu;
